import { Injectable, inject } from '@angular/core';
import {
    IRelatedProductsCallback,
    IRelatedProductsOptions,
    RelatedProductsService
} from '@df/catalog-ui/related-products/related-products.service';
import { IProductDataV2 } from '@df/catalog/product/product';
import { ProductResource } from '@df/catalog/product/product.resource';
import compact from 'lodash-es/compact';
import flattenDeep from 'lodash-es/flattenDeep';
import { IPioEngineRequestField } from '../core/interfaces';
import { PioRecommendService } from '../core/pio-recommend.service';

export interface IPioRelatedEngineOptions {
    /**
     * PIO engine to use (similar is default)
     */
    engine?: 'universal' | 'similar';
    /**
     * Category to filter result only from it
     */
    category?: number | number[];
    /**
     * If per suer recommendations should be used
     */
    user?: boolean;
    /**
     * Custom boost
     */
    boost?: IPioEngineRequestField | IPioEngineRequestField[];
}

@Injectable({
    providedIn: 'root'
})
export class PioEngine {
    protected pioRecommendService = inject(PioRecommendService);
    protected productResource = inject(ProductResource);

    get(sourceIds: number[], cb: IRelatedProductsCallback, engineOptions: IPioRelatedEngineOptions, options: IRelatedProductsOptions) {
        if (!this.pioRecommendService.enabled) {
            cb([]);
        } else {
            const promise = this.pioRecommendService.load(undefined, {
                engine: engineOptions.engine || 'similar',
                products: sourceIds,
                category: engineOptions.category,
                limit: 40,
                blacklist: this.blacklist(sourceIds),
                boost: engineOptions.boost,
                user: engineOptions.user || false
            });

            if (promise) {
                promise.then(function (result) {
                    cb(<number[]>result.products);
                });

                promise.catch(function (err) {
                    cb([]);
                });
            } else {
                cb([]);
            }
        }
    }

    /**
     * we are going to check this product family in case only one product
     * is visible in catalogue we gonna blacklist whole family that
     * is because it means that they no different like fashion sizes
     *
     * @param  {number[]} productIds
     * @return {number[]}
     */
    protected blacklist(productIds: number[]): number[] {
        return (
            compact<number>(
                flattenDeep<number>(
                    productIds.map((productId: number): number | number[] | undefined => {
                        const product = this.productResource.getExisting(productId);
                        if (!product) {
                            return productId;
                        }
                        if (product && product.data && (<IProductDataV2>product.data).isDivergent) {
                            return undefined;
                        }
                        return product.family.map(i => i.id);
                    })
                )
            ) || []
        );
    }
}

RelatedProductsService.registerEngine('pio', PioEngine);
